import {Component} from "@angular/core";

import {AppController} from "../AppController";

@Component({
  selector: "app-success-page",
  templateUrl: "./SuccessPage.html",
})
export class SuccessPage {

  public constructor(private readonly _appController: AppController) {}

  public get appController() {
    return this._appController;
  }

}
